export default __webpack_public_path__ + "static/media/Pendant of the Penitent Pilgrim.9aecef14.jpg";